import {
  takeLatest,
  put,
  select,
} from 'redux-saga/effects';
import { message } from 'antd';
import getMetricsData from '@api/metricContainer';
import * as actions from './actions';
import * as types from './types';
import * as helpers from './helper';
import * as baseTypes from '../base/types';
import { intervalSelector, filterSelector, selectedKPIConfigSelector } from '../base/selectors';
import { granularity as getGranularity } from '@utils';
import { autoRequest } from '@api/createRequestStore';
import {selectedThresholdConfigSelector} from '../spiThresholds/selectors';
import { audienceMetricsSelector } from './selectors';

function* getChartData() {
  yield put(actions.fetching());
  let interval = yield select(intervalSelector);
  const filter = yield select(filterSelector);
  const granularity = getGranularity(interval.from, interval.to, false, true);
  interval = `${interval.from}/${interval.to}`;
  const metrics = yield select(audienceMetricsSelector);
  const kpiConfig = yield select(selectedKPIConfigSelector);

  const payload = yield helpers.createQuery(metrics, interval, filter.rule, granularity, kpiConfig);
  try {
    yield autoRequest(getMetricsData, types.SCOPE, payload);
  } catch (error) {
    const errorMsg = error.message || 'Unknown error!';
    message.error(errorMsg);
  }
}

function* initRequest() {
  yield put(actions.init());
}

function* watchInitRequest() {
  yield takeLatest([
    types.INIT,
  ], initRequest);
}

function* watchParamChanges() {
  yield takeLatest([
    types.FETCH_DATA,
    baseTypes.SET_INTERVAL,
    baseTypes.APPLY_FILTER,
    baseTypes.SET_SELECTED_KPI_CONFIG
  ], getChartData);
}

export default [
  watchInitRequest,
  watchParamChanges,
];
